import { render, staticRenderFns } from "./OTSUCourse.vue?vue&type=template&id=e827e9b8&scoped=true"
import script from "./OTSUCourse.vue?vue&type=script&lang=js"
export * from "./OTSUCourse.vue?vue&type=script&lang=js"
import style0 from "./OTSUCourse.vue?vue&type=style&index=0&id=e827e9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e827e9b8",
  null
  
)

export default component.exports